module.exports = __webpack_public_path__ + "img/15.fdd41560.webp";